const moduleState = {
  loadingInitialLoader: true,
  loadingStationDetails: false,
  loadingStationAddEdit: false,
  loadingStationPoints: false,
  loadingNearestStations: false,
  loadingRouteStations: false,
  loadingAnalyzeResults: false,
  loadingAnalyzeStations: false,
  loadingCorridorStations: false,
};

const getters = {
  getLoadingInitialLoader: (state) => state.loadingInitialLoader,
  getLoadingStationDetails: (state) => state.loadingStationDetails,
  getLoadingStationAddEdit: (state) => state.loadingStationAddEdit,
  getLoadingStationPoints: (state) => state.loadingStationPoints,
  getLoadingNearestStations: (state) => state.loadingNearestStations,
  getLoadingRouteStations: (state) => state.loadingRouteStations,
  getLoadingAnalyzeResults: (state) => state.loadingAnalyzeResults,
  getLoadingAnalyzeStations: (state) => state.loadingAnalyzeStations,
  getLoadingCorridorStations: (state) => state.loadingCorridorStations,
};

const mutations = {
  setLoadingInitialLoader(state, status) {
    state.loadingInitialLoader = status;
  },

  setLoadingStationDetails(state, status) {
    state.loadingStationDetails = status;
  },

  setLoadingStationAddEdit(state, status) {
    state.loadingStationAddEdit = status;
  },

  setLoadingStationPoints(state, status) {
    state.loadingStationPoints = status;
  },

  setLoadingNearestStations(state, status) {
    state.loadingNearestStations = status;
  },

  setLoadingRouteStations(state, status) {
    state.loadingRouteStations = status;
  },

  setLoadingCorridorStations(state, status) {
    state.loadingCorridorStations = status;
  },

  setLoadingAnalyzeResults(state, status) {
    state.loadingAnalyzeResults = status;
  },

  setLoadingAnalyzeStations(state, status) {
    state.loadingAnalyzeStations = status;
  },
};

export default {
  state: moduleState,
  getters,
  mutations,
};
